import { CHANGE_LANG } from './types';

export const changeLang = lang => dispatch => {
  dispatch({
    type: CHANGE_LANG,
    payload: lang
  });
};
